export const CakeMark = ({ className = "w-9 h-9", stroke = "#C5A059" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <g stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
      <path d="M14 46h24v10H14z" />
      <path d="M18 36h16v10H18z" />
      <path d="M21 28h10v8H21z" />
      <path d="M26 28c0-3 2-4 2-6 0 2 2 3 2 6" />
      <path d="M46 14v16" />
      <path d="M46 30c0 8-3 12-6 14" />
      <path d="M46 30c0 9 0 12 0 14" />
      <path d="M46 30c0 8 3 12 6 14" />
    </g>
  </svg>
);

const Logo = ({ dark = false, compact = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <CakeMark className={compact ? "w-8 h-8" : "w-10 h-10"} />
    <div className="leading-none">
      <p
        className={`font-serif font-medium tracking-wide ${
          compact ? "text-xl" : "text-2xl"
        } ${dark ? "text-[#F9F6F0]" : "text-[#8B5D6C]"}`}
      >
        Velvet Bakes
      </p>
      {!compact && (
        <p
          className={`text-[10px] uppercase tracking-[0.28em] mt-1 ${
            dark ? "text-[#F9F6F0]/60" : "text-[#987885]"
          }`}
        >
          Sweet moments, beautifully baked
        </p>
      )}
    </div>
  </div>
);

export default Logo;
